export enum UserRole {
  CommitteeMember = 'committee_member',
  CommitteeDelegate = 'committee_delegate',
  ComplianceOfficer = 'compliance_officer',
  LpgCoordinator = 'lpg_coordinator',
  TcoBiddingSupport = 'bidding_support',
}
